// this function detects most providers injected at window.ethereum
// This does not work when this is imported as .js:
// import detectEthereumProvider from 'node_modules/@metamask/detect-provider/dist/index.js'
// import Web3 from 'node_modules/web3/dist/web3.min.js'
import WalletConnectProvider from '@walletconnect/web3-provider';
import detectEthereumProvider from '@metamask/detect-provider/dist/index';
import Web3 from 'web3/dist/web3.min';
import multihashes from 'multihashes';
console.log('Using web3 version: ', Web3.version);
const ethereum = window.ethereum;
if (!ethereum) {
    console.warn('Missing ethereum object in the global scope');
}
let autoConnectEnabled = true;
if (process.env.REACT_APP_AUTOCONNECT_ENABLED === 'false') {
    autoConnectEnabled = false;
}
const defaultEthereumProviders = {
    1: process.env.REACT_APP_MAINNET_PROVIDER_URL
        ? process.env.REACT_APP_MAINNET_PROVIDER_URL
        : 'wss://mainnet.infura.io/ws/v3/044bfbb71eeb4452a66feb7768d7a1b8',
    // There should be preferrably wss:// connection instead. You may need to run your own BSC node.
    56: process.env.REACT_APP_BSC_PROVIDER_URL
        ? process.env.REACT_APP_BSC_PROVIDER_URL
        : 'https://bsc-dataseed.binance.org/',
    137: process.env.REACT_APP_POLYGON_PROVIDER_URL
        ? process.env.REACT_APP_POLYGON_PROVIDER_URL
        : 'https://rpc-mainnet.maticvigil.com'
};
if (process.env.REACT_APP_ROPSTEN_PROVIDER_URL) {
    defaultEthereumProviders[3] = process.env.REACT_APP_ROPSTEN_PROVIDER_URL;
}
if (process.env.REACT_APP_RINKEBY_PROVIDER_URL) {
    defaultEthereumProviders[4] = process.env.REACT_APP_RINKEBY_PROVIDER_URL;
}
if (process.env.REACT_APP_LOCAL_PROVIDER_URL) {
    defaultEthereumProviders[333] = process.env.REACT_APP_LOCAL_PROVIDER_URL;
}
const zeroHash = '0x0000000000000000000000000000000000000000000000000000000000000000';
const defaultWalletConnectProvider = {
    infuraId: '07e180fc271d4e79a8a9fb1001f57a6b',
    rpc: {
        1: 'https://mainnet.infura.io/v3/07e180fc271d4e79a8a9fb1001f57a6b',
        56: 'https://bsc-dataseed.binance.org',
        137: 'https://rpc-mainnet.maticvigil.com'
    }
};
const walletProviders = [
    {
        id: 1,
        name: "MetaMask",
        logo: "https://raw.githubusercontent.com/snapshot-labs/lock/master/connectors/assets/metamask.png",
    },
    {
        id: 2,
        name: "WalletConnect",
        logo: "https://raw.githubusercontent.com/snapshot-labs/lock/master/connectors/assets/walletconnect.png",
    },
];
export class Ethereum {
    constructor(ethereumProviders = defaultEthereumProviders) {
        this.ethereumProviders = null;
        this.oldNetworkVersion = null;
        this.oldReadWeb3 = null;
        this.readWeb3Cache = {};
        this.writeWeb3 = null;
        this.provider = null;
        this.currentAccount = null;
        this.currentWalletProvider = null;
        this.ethereumProviders = ethereumProviders;
        ethereum === null || ethereum === void 0 ? void 0 : ethereum.on('chainChanged', handleChainChanged);
        ethereum === null || ethereum === void 0 ? void 0 : ethereum.on('accountsChanged', this.handleAccountsChanged);
        if (autoConnectEnabled) {
            window.addEventListener('load', () => this.onLoad());
        }
    }
    async onLoadHandler() {
        try {
            const providerId = localStorage.getItem('finance_vote_current_provider');
            if (providerId)
                this.currentWalletProvider = walletProviders.find(provider => provider.id === parseInt(providerId));
        }
        catch (err) {
            // provider still equals null
        }
        if (this.currentWalletProvider) {
            await this.connectWallet();
            this.writeWeb3 = new Web3(this.provider, {
                timeout: 30000,
                reconnect: {
                    auto: true,
                    delay: 5000,
                    maxAttempts: 5,
                    onTimeout: false
                }
            });
            if (!ethereum) {
                this.oldReadWeb3 = this.writeWeb3;
            }
            dispatchEvent(EVENTS.NETWORK_CHANGE, this.writeWeb3);
        }
        else {
            this.writeWeb3 = this.readWeb3();
            dispatchEvent(EVENTS.NETWORK_CHANGE, this.writeWeb3);
        }
    }
    onLoad() {
        try {
            this.onLoadHandler();
        }
        catch {
            this.onLoadHandler();
        }
    }
    readWeb3(network = null) {
        const networkVersion = network || (ethereum === null || ethereum === void 0 ? void 0 : ethereum.networkVersion) || 1;
        if (this.readWeb3Cache[networkVersion]) {
            return this.readWeb3Cache[networkVersion];
        }
        const providerURL = this.ethereumProviders[networkVersion];
        if (!providerURL) {
            console.error('Unsupported network:', networkVersion, 'Please add a node provider url to your .env file if you would like to support this network.');
            return null;
        }
        this.readWeb3Cache[networkVersion] = new Web3(getProvider(providerURL), {
            timeout: 30000,
            reconnect: {
                auto: true,
                delay: 5000,
                maxAttempts: 5,
                onTimeout: false
            }
        });
        return this.readWeb3Cache[networkVersion];
    }
    async getNetworkId() {
        return await this.readWeb3().eth.net.getId();
    }
    async getContract(platform, contract, { infuraOnly = false, infuraKey = '07e180fc271d4e79a8a9fb1001f57a6b', chainId = null } = {}) {
        const _chainId = chainId || await this.getChainId();
        const contractAddress = contract.networks[_chainId].address;
        if (!contracts[platform][_chainId]) {
            contracts[platform][_chainId] = {};
        }
        if (platform === 'read' && infuraOnly) {
            const provider = new Web3(new Web3.providers.HttpProvider(`https://mainnet.infura.io/v3/${infuraKey}`));
            const web3Contract = new (provider.eth.Contract)(contract.abi, contractAddress);
            const t = web3Contract;
            t.setProvider(provider.currentProvider);
            contracts[platform][_chainId][contractAddress] = t;
        }
        else if (!contracts[platform][_chainId][contractAddress]) {
            if (platform === 'write') {
                const t = await this.getWeb3Contract(contract, _chainId);
                t.setProvider(this.writeWeb3.currentProvider);
                contracts[platform][_chainId][contractAddress] = t;
            }
            else if (platform === 'read' && !infuraOnly) {
                const t = await this.getWeb3Contract(contract, _chainId);
                t.setProvider(this.readWeb3(_chainId).currentProvider);
                contracts[platform][_chainId][contractAddress] = t;
            }
        }
        return contracts[platform][_chainId][contractAddress];
    }
    async getChainId() {
        let chainId = 1;
        if (ethereum) {
            chainId = parseInt(await ethereum.request({ method: 'eth_chainId' }), 16);
        }
        return chainId;
    }
    async connectWallet() {
        var _a;
        if (!this.currentWalletProvider)
            return console.error('No wallet provider chosen');
        switch ((_a = this.currentWalletProvider) === null || _a === void 0 ? void 0 : _a.id) {
            case 1: // METAMASK
                this.provider = await detectEthereumProvider();
                await ethereum.request({ method: 'eth_requestAccounts' })
                    .then(this.handleAccountsChanged.bind(this))
                    .catch((err) => {
                    if (err.code === 4001) {
                        // EIP-1193 userRejectedRequest error
                        // If this happens, the user rejected the connection request.
                        console.log('Please connect to MetaMask.');
                    }
                    if (err.code === -32002) {
                        dispatchEvent(EVENTS.ERROR_METAMASK_ALREADY_IN_PROGRESS);
                    }
                    else {
                        console.error(err);
                    }
                });
                break;
            case 2: // WALLET CONNECT
                if (this.provider instanceof WalletConnectProvider && this.provider.isConnecting)
                    break;
                this.provider = new WalletConnectProvider(defaultWalletConnectProvider);
                await this.provider.enable()
                    .then(this.handleAccountsChanged.bind(this))
                    .catch((err) => {
                    this.provider.isConnecting = false;
                    console.log(err);
                });
                this.provider.on('accountsChanged', this.handleAccountsChanged.bind(this));
                this.provider.on("disconnect", () => { console.log('disconnected'); this.handleAccountsChanged([]); });
                break;
        }
    }
    async signPersonalMessage(msg, address) {
        var _a;
        msg = toHex(Buffer.from(msg, "utf8"));
        switch ((_a = this.currentWalletProvider) === null || _a === void 0 ? void 0 : _a.id) {
            case 1: // METAMASK
                return ethereum.request({
                    method: "personal_sign",
                    params: [msg, address]
                });
            case 2: // WALLET CONNECT
                return this.provider.signPersonalMessage([msg, address]);
        }
    }
    async disconnectWalletConnect() {
        await this.provider.disconnect();
    }
    isWalletConnected() {
        return this.currentAccount != null;
    }
    getCurrentProvider() {
        return this.provider;
    }
    async getEthAccount(connectWallet = true) {
        const customAccount = localStorage.getItem('customAddress');
        if (!this.currentAccount && customAccount) {
            this.currentAccount = customAccount;
        }
        if (!this.currentAccount) {
            if (connectWallet)
                await this.connectWallet();
            if (!this.currentAccount) {
                const msg = 'Please ensure that metamask or another browser wallet is installed and activated to use this feature';
                console.error(msg);
                // alert(msg);
                throw msg;
            }
        }
        return this.currentAccount;
    }
    // For now, 'eth_accounts' will continue to always return an array
    handleAccountsChanged(accounts) {
        var _a, _b;
        console.log('accounts', (_a = accounts[0]) === null || _a === void 0 ? void 0 : _a.toLowerCase());
        if (accounts.length === 0) {
            // MetaMask is locked or the user has not connected any accounts
            this.currentAccount = null;
        }
        else {
            this.currentAccount = (_b = accounts[0]) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        }
        // Do any other work!
        document.dispatchEvent(new Event('account_changed'));
        if (!accounts[0]) {
            dispatchEvent(EVENTS.ACCOUNTS_DISCONNECTED);
        }
    }
    async getWeb3Contract(contractAbi, chainId = null) {
        const _chainId = chainId || await this.getChainId();
        const contractAddress = contractAbi.networks[_chainId].address;
        const web3Contract = new (this.readWeb3(_chainId).eth.Contract)(contractAbi.abi, contractAddress);
        return web3Contract;
    }
    async getReadContractByAddress(contract, address, network = null) {
        const t = new (this.readWeb3(network).eth.Contract)(contract.abi, address);
        t.setProvider(this.readWeb3(network).currentProvider);
        return t;
    }
    async getWriteContractByAddress(contract, address, network = null) {
        const t = new (this.readWeb3(network).eth.Contract)(contract.abi, address);
        t.setProvider(this.writeWeb3.currentProvider);
        return t;
    }
    async getAllEvents(callback, contractAbi, eventName, filter, fromBlock = 0, toBlock = 'latest', eventSignature, eventInputs, subscribe = true) {
        const web3Contract = await this.getWeb3Contract(contractAbi);
        web3Contract.getPastEvents(eventName, {
            filter: filter,
            fromBlock: fromBlock,
            toBlock: toBlock
        }, (error, events) => {
            if (error) {
                console.error(error);
                return;
            }
            for (var i = 0; i < events.length; i++) {
                const event = events[i];
                event.returnValues.txHash = event.transactionHash;
                callback(event.returnValues);
            }
        });
        if (subscribe) {
            this.subscribeLogEvent(web3Contract, eventName, eventSignature, eventInputs, (event) => {
                callback(event);
            });
        }
    }
    subscribeLogEvent(contract, eventName, eventSig, eventInputs, callback) {
        this.readWeb3().eth.subscribe('logs', {
            address: contract._address,
            topics: [eventSig],
            fromBlock: 'latest' // https://ethereum.stackexchange.com/a/34693/36438
        }, (error, result) => {
            if (!error) {
                console.log('result', result);
                const eventObj = this.readWeb3().eth.abi.decodeLog(eventInputs, result.data, result.topics.slice(1));
                eventObj.txHash = result.transactionHash;
                callback(eventObj);
            }
            else {
                console.error(`Error making subscription to ${eventName} on ${contract.address}: ${error}`);
            }
        });
    }
    async isUserManagement(contract) {
        let isManagement = false;
        if (this.writeWeb3) {
            const accounts = await this.writeWeb3.eth.getAccounts();
            const metamaskAddr = accounts[0];
            const managementAddr = await this.getManagementAddress(contract);
            isManagement = metamaskAddr === managementAddr;
        }
        return isManagement;
    }
    async getManagementAddress(contract) {
        const c = await this.getContract('read', contract);
        const mgmt = await c.methods.management().call();
        return mgmt;
    }
    async getBlock(block) {
        return this.readWeb3().eth.getBlock(block);
    }
    getWalletProviders() {
        const providers = walletProviders.filter((provider) => {
            if (provider.id === 1 && !window.ethereum)
                return false;
            return true;
        });
        return providers;
    }
    async setWalletProvider(provider) {
        this.currentWalletProvider = provider;
        localStorage.setItem('finance_vote_current_provider', provider.id);
        await this.connectWallet();
        // try to connect wallet
    }
}
const listeners = {};
const EVENTS = {
    ACCOUNTS_DISCONNECTED: 'accountsDisconnected',
    ERROR_METAMASK_ALREADY_IN_PROGRESS: 'errorMetamaskAlreadyInProgress',
    NETWORK_CHANGE: 'networkChange'
};
function dispatchEvent(eventName, ...args) {
    const handlers = listeners[eventName];
    if (handlers) {
        handlers.forEach(handler => handler(...args));
    }
}
function addEventListener(eventName, handler) {
    let handlers = listeners[eventName];
    if (!handlers) {
        handlers = listeners[eventName] = [];
    }
    handlers.push(handler);
}
function removeEventListener(eventName, handler) {
    const handlers = listeners[eventName];
    if (handlers) {
        const index = handlers.indexOf(handler);
        handlers.splice(index, 1);
    }
}
export const eventListeners = {
    EVENTS,
    addEventListener,
    removeEventListener
};
/**********************************************************/
/* Handle chain (network) and chainChanged (per EIP-1193) */
/**********************************************************/
// Normally, we would recommend the 'eth_chainId' RPC method, but it currently
// returns incorrectly formatted chain ID values.
// const currentChainId = ethereum?.chainId
// TODO: Should it be made optional? (for the case if we only read blockchain)
function handleChainChanged(_chainId) {
    // We recommend reloading the page, unless you must do otherwise
    window.location.reload();
}
const contracts = { read: {}, write: {} };
export function getProvider(url) {
    const provider = /^http/.test(url)
        ? new Web3.providers.HttpProvider(url)
        : new Web3.providers.WebsocketProvider(url);
    return provider;
}
export function bytesToString(bytes) {
    return Web3.utils.hexToString(bytes);
}
export function toChecksumAddress(address) {
    return Web3.utils.toChecksumAddress(address);
}
export function fromWei(num) {
    return Web3.utils.fromWei(num);
}
export function toWei(num) {
    return Web3.utils.toWei(num);
}
export function toBN(num) {
    return Web3.utils.toBN(num);
}
export function sha3(arg) {
    return Web3.utils.sha3(arg);
}
export function asciiToHex(ascii) {
    return Web3.utils.asciiToHex(ascii);
}
export function toHex(data) {
    return Web3.utils.toHex(data);
}
export function toEthDate(date) {
    return date.getTime() / 1e3;
}
export function fromEthDate(timestamp) {
    return new Date(timestamp * 1e3);
}
const IPFS_GATEWAYS = [
    "gateway.pinata.cloud",
    "ipfs.infura.io",
    "cloudflare-ipfs.com",
    "cf-ipfs.com",
    "ipfs.io",
    "ipfs.fleek.co",
    "dweb.link"
];
export async function ipfsGet(ipfsHash, failoverCallback) {
    for (let i = 0; i < IPFS_GATEWAYS.length; i++) {
        try {
            const url = `https://${IPFS_GATEWAYS[i]}/ipfs/${ipfsHash}`;
            return await fetch(url).then((res) => res.json());
        }
        catch (er) {
            // console.error(er);
            // try another gateway
        }
    }
    return failoverCallback ? failoverCallback() : false;
}
export const ethInstance = new Ethereum();
export function generateRandomData(numLeaves) {
    const web3 = ethInstance.readWeb3();
    const addressLeaves = [{ "address": "0x90F8bf6A479f320ead074411a4B0e7944Ea8c9C1" }];
    const metadataLeaves = [{ "uri": "blahblahblah", "tokenId": "1" }];
    for (let i = 0; i < numLeaves; i++) {
        if (i % 10000 == 0) {
            console.log({ i });
        }
        addressLeaves.push({ "address": web3.utils.randomHex(20) });
        metadataLeaves.push({ "uri": "ipfs://" + web3.utils.randomHex(20), "tokenId": web3.utils.randomHex(20) });
    }
    return { addressLeaves, metadataLeaves };
}
export function createMerkleProof(tree, target, targetKey) {
    const web3 = ethInstance.readWeb3();
    const leaf = tree.nodes.find((x) => x.data[targetKey] == target);
    let x = { ...leaf };
    const proof = [];
    while (x.parentIndex > -1) {
        const parent = tree.nodes[x.parentIndex];
        const flip = x.index === parent.leftChildIndex;
        if (flip) {
            proof.push(tree.nodes[parent.rightChildIndex].hash);
        }
        else {
            proof.push(tree.nodes[parent.leftChildIndex].hash);
        }
        x = parent;
    }
    return proof;
}
export function getLeafHash(obj, hashTypes, hashKeys) {
    const web3 = ethInstance.readWeb3();
    return web3.utils.sha3(web3.eth.abi.encodeParameters(hashTypes, hashKeys.map(x => obj[x])));
}
export function checkMerkleProof(proof, root, obj, hashTypes, hashKeys) {
    let a = getLeafHash(obj, hashTypes, hashKeys);
    for (let i = 0; i < proof.length; i++) {
        let b = proof[i];
        // console.log('proof step', { a, b })
        let p = parentHash(a, b);
        a = p[0];
    }
    const correct = a === root;
    // console.log({ correct, a, root })
    return correct;
}
export function createMerkleTree(leaves, hashTypes, hashKeys) {
    let numNodes = 0;
    let allNodes = leaves.map(x => {
        const hash = getLeafHash(x, hashTypes, hashKeys);
        return {
            index: numNodes++,
            data: x,
            hash: hash,
            parentIndex: -1,
            leftChildIndex: -1,
            rightChildIndex: -1
        };
    });
    let currentRow = allNodes.map((x) => x.index);
    let parentRow = [];
    let allRows = [];
    while (currentRow.length > 1) {
        console.log({ currentRow });
        // handle case where the tree is not binary by adding zero hash
        if (currentRow.length % 2) {
            allNodes.push({
                index: numNodes++,
                hash: zeroHash,
                data: null,
                parentIndex: -1,
                leftChildIndex: -1,
                rightChildIndex: -1
            });
            currentRow.push(numNodes - 1);
        }
        // loop over current row
        for (let i = 0; i < currentRow.length; i += 2) {
            const [pHash, flip] = parentHash(allNodes[currentRow[i]].hash, allNodes[currentRow[i + 1]].hash);
            const newNode = {
                index: numNodes++,
                hash: pHash,
                data: null,
                parentIndex: -1,
                leftChildIndex: flip ? allNodes[currentRow[i + 1]].index : allNodes[currentRow[i]].index,
                rightChildIndex: flip ? allNodes[currentRow[i]].index : allNodes[currentRow[i + 1]].index
            };
            allNodes[currentRow[i]].parentIndex = numNodes - 1;
            allNodes[currentRow[i + 1]].parentIndex = numNodes - 1;
            allNodes.push(newNode);
            parentRow.push(newNode.index);
        }
        // keep track of rows
        allRows.push(currentRow);
        // move pointer to next row
        currentRow = parentRow;
        // zero out parent
        parentRow = [];
    }
    allRows.push(currentRow);
    return { rows: allRows, nodes: allNodes, root: allNodes[currentRow] };
}
export function parentHash(a, b) {
    const web3 = ethInstance.readWeb3();
    if (a < b) {
        return [web3.utils.sha3(a + b.slice(2)), false];
    }
    else {
        return [web3.utils.sha3(b + a.slice(2)), true];
    }
}
function buf2hex(buffer) {
    // buffer is an ArrayBuffer
    return [...new Uint8Array(buffer)].map((x) => x.toString(16).padStart(2, '0')).join('');
}
export function ipfsHashToBytes32(ipfsHash) {
    const bytes = '0x' + buf2hex(multihashes.fromB58String(ipfsHash)).slice(4);
    console.log(bytes);
    return bytes;
}
;
export function bytes32ToIpfsHash(bytes32Hex) {
    // Add our default ipfs values for first 2 bytes:
    // function:0x12=sha2, size:0x20=256 bits
    // and cut off leading "0x"
    const hashHex = "1220" + bytes32Hex.slice(2);
    const hashBytes = Buffer.from(hashHex, "hex");
    const hashStr = multihashes.toB58String(hashBytes);
    console.log(hashStr);
    return hashStr;
}
